import { snakeCase } from 'lodash';
import {
    REQUEST_GET,
    REQUEST_POST,
    REQUEST_PUT,
    REQUEST_DELETE,
} from '../constants/definitions';

export const formatQueryKey = ( key ) => {

    if( key.includes( '[' ) ){
        return key;
    }
    return snakeCase( key );
};

export const validateHttpMethod = ( httpMethod ) => {
    if( ![ REQUEST_GET, REQUEST_POST, REQUEST_PUT, REQUEST_DELETE ].includes( httpMethod ) ){
        throw new Error( 'Method not allowed' );
    }
};
